module.exports = __webpack_public_path__ + "static/media/3.e2fc86a0.png";